import { Stack, Typography } from '@mui/material'

/**
 * Secondary line: reasoning / timing copy (e.g. “Thought for 4s”).
 * @param {{ children: React.ReactNode }} props
 */
export function AgentThoughtSummaryLine({ children }) {
  if (children == null || children === '') return null
  return (
    <Stack
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
      sx={{
        flex: 1,
        minWidth: 0,
        minHeight: 19,
        boxSizing: 'border-box',
        color: 'var(--app-text-tertiary)',
        opacity: 0.85,
        transition:
          'opacity var(--app-motion-duration-base, 220ms) var(--app-motion-ease-out-soft, cubic-bezier(0.22, 1, 0.36, 1)), color var(--app-motion-duration-base, 220ms) var(--app-motion-ease-out-soft, cubic-bezier(0.22, 1, 0.36, 1))',
      }}
    >
      <Typography
        component="div"
        sx={{
          width: '100%',
          fontFamily: 'var(--app-font-sans)',
          fontWeight: 'var(--app-font-weight-medium)',
          fontSize: 'var(--app-thought-font-size)',
          lineHeight: 'var(--app-thought-line-height)',
          letterSpacing: 0,
          display: 'flex',
          alignItems: 'center',
          color: 'inherit',
        }}
      >
        {children}
      </Typography>
    </Stack>
  )
}
